/*=========================================================================================
  File Name: state.js
  Description: Vuex Store - state
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import navbarSearchAndPinList from "@/layouts/components/navbar/navbarSearchAndPinList"
import themeConfig from "@/../themeConfig.js"
import colors from "@/../themeConfig.js"


// /////////////////////////////////////////////
// Variables
// /////////////////////////////////////////////

const userDefaults = {
  displayName : localStorage.user?JSON.parse(localStorage.user).displayName:'', // From Auth
  company     : localStorage.user?JSON.parse(localStorage.user).company:'',
  photo       : localStorage.user?JSON.parse(localStorage.user).photo:'', // From Auth
  type        : localStorage.user?JSON.parse(localStorage.user).type:'',
  userRole    : localStorage.user?JSON.parse(localStorage.user).roleName:'',
  access      : localStorage.user?JSON.parse(localStorage.user).access:'',
  token       : localStorage.user?JSON.parse(localStorage.user).token:'',
}

// /////////////////////////////////////////////
// State
// /////////////////////////////////////////////

const Roles = {
 BIZ_CUSTOMER:"0000",
 SM_DASHBOARD:"0000",
 TICKET_CONFIG:"0000",
 SM_CONFIG:"0000",
 SM_TEAM:"0000",
 SM_ROLE:"0000",
 ASSET_HARDWARE:"0000",
 TICKET_SUPPORT:"0000",
 APPLY_TICKET:"0000",
 SM_DEPARTMENT:"0000",
 ASSET_TYPE:"0000",
 BIZ_PROVIDER:"0000",
 ASSET_SOFTWARE:"0000",
 ASSET_ZONE:"0000",
 SM_USER:"0000",
 ASSET_LICENSE:"0000"
}

const state = {
    bodyOverlay             : false,
    isVerticalNavMenuActive : true,
    mainLayoutType          : themeConfig.mainLayoutType || "vertical",
    navbarSearchAndPinList  : navbarSearchAndPinList,
    reduceButton            : themeConfig.sidebarCollapsed,
    verticalNavMenuWidth    : "default",
    verticalNavMenuItemsMin : false,
    sidebarLeft:false,
    scrollY                 : 0,
    starredPages            : navbarSearchAndPinList.data.filter((page) => page.highlightAction),
    theme                   : themeConfig.theme || "light",
    themePrimaryColor       : colors.primary,
    defaultAvatar    : require("@/assets/images/portrait/small/defaultAvatar.jpg"),
    // Can be used to get current window with
    // Note: Above breakpoint state is for internal use of sidebar & navbar component
    windowWidth: null,
    title: '',
    company: localStorage.user?JSON.parse(localStorage.user).company:'',
    companyLogo: localStorage.user?JSON.parse(localStorage.user).photo:'',
    refresh: 0,
    roles: {},
    loading:true,
    pageSize:15,
    locale: localStorage.getItem('locale') ? localStorage.getItem('locale') : '',

    myUsers:localStorage.users?JSON.parse(localStorage.users):[],
    // user
    AppUser: {
      accountNo   : localStorage.user?JSON.parse(localStorage.user).accountNo:'', // From Auth
      displayName : localStorage.user?JSON.parse(localStorage.user).displayName:'', // From Auth
      company     : localStorage.user?JSON.parse(localStorage.user).company:'',
      photo       : localStorage.user?JSON.parse(localStorage.user).photo:'', // From Auth
      type        : localStorage.user?JSON.parse(localStorage.user).type:'',
      userRole    : localStorage.user?JSON.parse(localStorage.user).roleName:'',
      access      : localStorage.user?JSON.parse(localStorage.user).access:Roles,
      token       : localStorage.user?JSON.parse(localStorage.user).token:'',
      trust       : localStorage.user?JSON.parse(localStorage.user).trust:'',
      departmentId: localStorage.user?JSON.parse(localStorage.user).departmentId:'',
      departmentName: localStorage.user?JSON.parse(localStorage.user).departmentName:'',
    },
    chartDefaultColors:[ '#3FA1FF','#3ECBCB','#50CB74', '#FBD444', '#ED561B', '#8643E0'],
    chartPriorityColors:[ '#3b7b34','#ff9f43','#ea5455', '#1e65b5', '#ED561B', '#8643E0'],
    
    hardwares: [],
    selectHardwares: [],
    hardwareShowList: [],
    hardwareSelectId: {}
}

export default state
